import { h } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';

const YotpoStars = ({
  currentProduct,
  currentVariant,
  isProductPage = false,
}) => {
  const starsWrapper = useRef()
  const [isInitiated, setIsInitiated] = useState(false)
  const [isObserverInitiated, setIsObserverInitiated] = useState(null)
    useEffect(() => {
      if (!starsWrapper?.current || isInitiated || !isProductPage) return null
      if (window.yotpo?.initWidgets){
        window.yotpo.initWidgets();
        setIsInitiated(true)
      }
      if (isObserverInitiated) return null;
      const callback = (mutations, observer) => {
        const countStars = document.querySelector('.product-form .yotpo-bottomline .yotpo-stars + a');
        if (countStars){
          const initialText = countStars?.textContent;
          countStars.textContent = initialText?.replace('Reviews', TMW.Strings.product.reviews);
          countStars.href = '#yotpo-reviews-main-widget';
          observer.disconnect();
        }
      }
      const options = {
        CharacterData: false,
        childList: true,
        subtree: true,
        attributes: false,
      }
      const observer = new MutationObserver(callback);
      observer.observe(starsWrapper.current, options);
      setIsObserverInitiated(true)
      return () => observer.disconnect();
    }, [starsWrapper])

    const initReviewsLink = () => {
      window.location.hash = ''
      window.location.hash = '#yotpo-reviews-main-widget'
    }

  return (
    <div
      ref={starsWrapper}
      id={`yotpo-id-${String(currentProduct?.id).replace('gid://shopify/Product/', '')}`}
      className="yotpo bottomLine"
      data-appkey="sxlMWStgmPhnj1ZOcuLcQXQJ1uCyum2s7dUraCMH"
      data-domain={window.TMW.shopUrl}
      onClick={initReviewsLink}
      data-product-id={String(currentProduct?.id).replace('gid://shopify/Product/', '')}
      data-product-models={String(currentProduct?.id).replace(
        'gid://shopify/Product/',
        '',
      )}
      data-name={currentProduct?.title}
      data-url={`${window.TMW.shopUrl}/product/${currentProduct?.handle}`}
      data-image-url={currentVariant?.image?.url}
      data-description={currentProduct?.description}
      data-bread-crumbs={currentProduct?.tags.join(';')}
    ></div>
  );
};

export default YotpoStars;
